/**
 * @author evdokimov
 */
import LeavesEditFormConfigController from './edit_config_controller/leaves/LeavesEditFormConfigController'
import BaseFormMediator from './BaseFormMediator'
import ScrollUtils from '../util/ScrollUtils'
import {arrayToMap} from '../atUtils'
import LeavesReportStore from './leavesReport/LeavesReportStore'
import _ from 'underscore'
import LeaveHTMLPreviewGenerator from './preview/html/leave/LeaveHTMLPreviewGenerator'
import LeaveCSVPreviewGenerator from './preview/csv/leave/LeaveCSVPreviewGenerator'
import ATReportParamsStringBuilder from './reportParamsStringBuilder/ATReportParamsStringBuilder'

export default function LeaveTimeFormMediator() {}

LeaveTimeFormMediator.prototype = _.create(BaseFormMediator.prototype)

LeaveTimeFormMediator.prototype.init = function(config) {
    BaseFormMediator.prototype.init.call(this, config);

    ATReportsStore.setVisibleUsers(config.users);
    ATReportsStore.setUserGroups(config.userGroups);
    ATReportsStore.setTimeZoneGroups(config.timeZoneGroups);

    this.validateAndUpdateUIIfInvalid();
    return this;
};

LeaveTimeFormMediator.prototype.initParamsStringBuilder = function(config) {
    return new ATReportParamsStringBuilder({
        data: {
            users: config.users,
            userGroups: config.userGroups,
            timeZoneGroups: config.timeZoneGroups,
            leaveTypesMap: arrayToMap(config.leavesData),
            manageableUserIds: ATReportsStore.getManageableUserIds(),
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    })
}

LeaveTimeFormMediator.prototype.initEditConfigController = function(config) {
    const self = this;
    const controller =  new LeavesEditFormConfigController();
    controller.setState({
        loggedInUserId: config.loggedInUserId
    });
    controller.init(
            {
                panelId: "mainContainer",
                reportAuthorizationInfo: config.reportAuthorizationInfo,
                reportParameters: config.reportParameters,
                users: config.users,
                manageableUsersIds: config.manageableUserIds,
                userGroups: config.userGroups,
                timeZoneGroups: config.timeZoneGroups,
                leavesData: config.leavesData,
                changeCallback: function() {self.changeParametersCallback()},
                productSettingsValidator: new ATProductSettingsValidator(),
                reportRightsValidator: new ATReportRightsValidator()
            });

    return controller;
};

LeaveTimeFormMediator.prototype.initCsvGenerator = function() {
    return new LeaveCSVPreviewGenerator().init();
};

LeaveTimeFormMediator.prototype.initHtmlGenerator = function() {
    return new LeaveHTMLPreviewGenerator()
};

LeaveTimeFormMediator.prototype.createDateRangeSelector = function(reportParameters) {
    const dateRangeMenuItemsUtil = new DateRangeMenuItemsUtil();
    const futureValidator = function() {
        return dateRangeMenuItemsUtil.isShowTTFItems(reportParameters.dateRangeSelection.qualifier);
    };

    const dateRangeSelectorConfig = {
        dateRangeSelection: reportParameters.dateRangeSelection,
        menuStates: dateRangeMenuItemsUtil.createDateRangeMenuItemsWithFuture(futureValidator), //for future items
        shortDateFormat: true,
        callOnChangeCallbackIfInvalid: true
    };

    return new DateRangeSelectorController().init(dateRangeSelectorConfig);
};

LeaveTimeFormMediator.prototype.generateCSVPreview = function(reportParameters) {
    BaseFormMediator.prototype.generateCSVPreview.apply(this, arguments)
    this._initCSVPreviewCustomScroll(this.reportPreviewPlaceholder);
};

/**
 * NOTE: this method can be used for all csv previews (need to move it in base formMediator)
 * Init custom scroll used iScroll library
 * for ie8 used standard scroll with custom mousewhell event that prevent default scrolling and allow hor scrolling
 * @param placeholderEl placeholder element (scroll wrapper) important! first child will be scrolled
 * @private
 */
LeaveTimeFormMediator.prototype._initCSVPreviewCustomScroll = function(placeholderEl) {
    ScrollUtils.addHorizontalScroll(placeholderEl, {isFaded: false});
};

LeaveTimeFormMediator.prototype.exportToCSV = function() {
    const reportParams = this.collectReportParameters();

    const successMethod = function(data) {
        const info = {};
        const groupingLevels = BaseReport.ConvertUtils.getGroupingLevels(reportParams);
        for (let i = 0; i < data["groupingLevelsInfoLists"].length; ++i) {
            const groupingType = BaseReport.ConvertUtils.getGroupingType(i, groupingLevels);
            info[groupingType] = arrayToMap(data["groupingLevelsInfoLists"][i]);
        }

        LeavesReportStore.setReportData(data["rootItem"], info);
        LeavesReportStore.mergeGeneralStore(ATReportsStore);
        LeavesReportStore.setReportParams(reportParams);
        return new LeaveCSVJsonConverter().init({
            defaultWorkDayDuration: data.defaultWorkDayDuration,
            store: LeavesReportStore,
            reportParamsStringBuilderConstructor: ATReportParamsStringBuilder,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
        })
    };

    this._exportToCSV(reportParams, successMethod, "LeavesReportService.getLeavesReport", [this.makeServiceParams(reportParams)]);
};

LeaveTimeFormMediator.prototype.generateCSVName = function(generator, reportParams) {
    return generator.generateCSVName(reportParams, new ATProductSettingsValidator(), UserRights.MANAGE_PTO_AND_SICK);
};


// WEBPACK FOOTER //
// ./web/js/reports/LeaveTimeFormMediator.js